import { Modal, Button } from "../../../ui/index.ts";

import styles from "./discard-assigned-changes-modal.module.css";

export type DiscardAssignedChangesConfirmModalProps = {
  open: boolean;
  projectName: string;
  variant: "toolbar" | "navigation";
  onConfirm: () => void;
  onCancel: () => void;
};

export function DiscardAssignedChangesConfirmModal({
  open,
  projectName,
  variant,
  onConfirm,
  onCancel,
}: DiscardAssignedChangesConfirmModalProps) {
  const bodyCopy =
    variant === "navigation" ? (
      <>
        Closing the panel or switching projects will lose unsaved changes for{" "}
        <strong className="sub-heading-sm" style={{ color: "var(--content)" }}>
          {projectName}
        </strong>
        .
      </>
    ) : (
      <>
        Discarding will revert your edits for{" "}
        <strong className="sub-heading-sm" style={{ color: "var(--content)" }}>
          {projectName}
        </strong>
        .
      </>
    );

  return (
    <Modal
      open={open}
      onClose={onCancel}
      title="Discard changes?"
      footer={
        <div className={styles.footerActions}>
          <Button type="button" variant="muted-outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      }
    >
      <p className="body-sm" style={{ margin: 0, color: "var(--content-muted)" }}>
        {bodyCopy}
      </p>
    </Modal>
  );
}
